// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style__spinner__1HPu1"};